/**
 * Formats a Date object or date-like value to 'YYYY-MM-DD' in local timezone.
 * @param {Date|string|number} dateInput 
 * @returns {string}
 */
export const getLocalDateString = (dateInput = new Date()) => {
  if (!dateInput) return '';
  const d = new Date(dateInput);
  if (isNaN(d.getTime())) return '';
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
